import { gql } from '@apollo/client';

export const CREATE_LEADERSHIP_POST = gql`
    mutation CreateLeadershipPost($title: String!, $description: String!, $type: String!, $imageIds: [Int], $pollOptions: [String], $pollAllowMultiple: Boolean, $pollAllowOther: Boolean, $pollClosesAt: String) {
        createLeadershipPost(title: $title, description: $description, type: $type, imageIds: $imageIds, pollOptions: $pollOptions, pollAllowMultiple: $pollAllowMultiple, pollAllowOther: $pollAllowOther, pollClosesAt: $pollClosesAt) {
            ... on LeadershipUpdate {
                id
                title
                description
                type
                images {
                    id
                    url
                    contentType
                    durationSeconds
                }
            }
            ... on Poll {
                id
                title
                description
                type
                images {
                    id
                    url
                    contentType
                    durationSeconds
                }
            }
            ... on LeadershipPrayerRequest {
                id
                title
                description
                type
                images {
                    id
                    url
                    contentType
                    durationSeconds
                }
            }
        }
    }
`;
